import { useEffect } from 'react';
import isNil from 'lodash/isNil';
type PropsT = {
  mediaElement: HTMLVideoElement | HTMLAudioElement | null;
  src: string;
  isPlaying: boolean | null;
};
export function useUpdateIsPlaying({
  mediaElement,
  src,
  isPlaying
}: PropsT) {
  useEffect(() => {
    if (isNil(isPlaying)) {
      return;
    }
    if (!mediaElement) {
      return;
    }
    if (isPlaying) {
      mediaElement.play();
    } else {
      mediaElement.pause();
    }
    // Including `src` in the dependency array ensures the video plays/pauses
    // whenever the source changes, restoring the last known play/pause state.
  }, [isPlaying, mediaElement, src]);
}